import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { Suspense } from 'react';
import { NotFoundPage } from '@/features/errors/NotFoundPage';
import { AuthErrorPage } from '@/features/errors/AuthErrorPage';
import { AppErrorPage } from '@/features/errors/AppErrorPage';

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundPage,
  errorComponent: RootErrorComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV && (
        <Suspense fallback={null}>
          <TanStackRouterDevtools position="bottom-right" />
        </Suspense>
      )}
    </>
  );
}

interface RootErrorComponentProps {
  error: Error;
  reset?: () => void;
}

/**
 * Errore di render/loader di una rotta. Gli errori di autenticazione hanno la loro pagina;
 * tutto il resto **non è un 404**: prima si mostrava `NotFoundPage`, e un crash del
 * contenuto sembrava una pagina inesistente (è così che il bug della vista "ore per
 * commessa" si è presentato come "Pagina non trovata").
 */
function RootErrorComponent({ error, reset }: RootErrorComponentProps) {
  const message = error.message ?? '';
  const isAuthError =
    /unauthor|forbidden|401|403|sessione|token|expired/i.test(message) ||
    /AuthError|Unauthorized/i.test(error.name ?? '');

  if (isAuthError) {
    return <AuthErrorPage reason={message} />;
  }
  return <AppErrorPage error={error} reset={reset} />;
}
